"use client";

import { usePathname } from "@/i18n/routing";
import { useLayoutEffect } from "react";
import { hasAdsRuntime, isAdFreePath } from "@/lib/ads/policy";

export default function AdsNavigationGuard() {
  const pathname = usePathname();
  useLayoutEffect(() => {
    // Scripts survive SPA navigation under the shared root layout. Reset the
    // document if Auto Ads was loaded; direct dashboard visits need no reload.
    if (isAdFreePath(pathname) && hasAdsRuntime(document)) {
      window.location.reload();
    }
  }, [pathname]);
  return null;
}
